import { responsiveFontSizes, Theme } from "@mui/material/styles";
import theme from "./tableTheme";

const tableMain: Theme = {
  ...theme,
};

export default responsiveFontSizes(tableMain);
